module.exports = {"us":[{"id":1234,"category":"python","slug":"python-course","title":"Test"}],"es":[{"id":1234,"category":"python","slug":"curso-programacion-python","title":"prueba"}]}


//////////////////
// WEBPACK FOOTER
// ./src/courses/course_list.json
// module id = 1UwQ
// module chunks = 1